const LensDetails = {
    create: () => "store/additional/lens-details",
    list: () => "store/additional/lens-details",
    delete: (id:string) => `store/additional/lens-details/${id}`,
    update: (id:string) => `store/additional/lens-details/${id}`,
    getById: (id:string) => `store/additional/lens-details/${id}`,
}

export default LensDetails